import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, IntlShape } from 'react-intl';
import { IDeliveryItemDetailsDTO, IEntityRoleDTO } from '../../../../../api/events.dao';
import DefaultButton from '../../../../global/default-button/default-button';
import { MultiSelectButton } from '../../../../global/multi-select/multi-select-button';
import Text from '../../../../global/text/text';
import { DeliveryTeamRole } from './delivery-team-role/delivery-team-role';
import { REMOVE_TEXT, addText, cancelText } from '../../../../../constants/common-labels.constants';

interface IDeliveryTeamProps {
    removeDeliveryItem: (username: string) => void;
    fetchDeliveryTeamItems: () => Promise<void>;
    setAssignedDeliveryTeam: (deliveryTeamItems: IDeliveryItemDetailsDTO[]) => void;
    searchDeliveryTeamItems: (query: string) => void;
    assignedDeliveryTeamItems: IDeliveryItemDetailsDTO[];
    selectableDeliveryTeamItems: IDeliveryItemDetailsDTO[];
    deliveryMemberRoles: IEntityRoleDTO[];
    setDeliveryMemberRole: (username: string, role: string) => void;
    intl: IntlShape;
}

export const DeliveryTeam = mobxReact.observer((props: IDeliveryTeamProps) => {

    const {
        removeDeliveryItem,
        fetchDeliveryTeamItems,
        searchDeliveryTeamItems,
        setAssignedDeliveryTeam,
        assignedDeliveryTeamItems,
        selectableDeliveryTeamItems,
        deliveryMemberRoles,
        setDeliveryMemberRole,
        intl,
    } = props;

    return (
        <div className='event_form__items-section'>
            <div className='event_form__items-section__title'>
                <FormattedMessage
                    id='oe.common.deliveryTeam'
                    description='Title text'
                    defaultMessage='Delivery Team'
                />
            </div>
            <div className='event_form__items-section__selected-items'>
                {!assignedDeliveryTeamItems.length ?
                    <div className='event_form__items-section__message'>
                        <FormattedMessage
                            id='oe.event.noDeliveryItems'
                            description='Placeholder text'
                            defaultMessage='Event has no assigned delivery members'
                        />
                    </div> :
                    assignedDeliveryTeamItems
                        .slice()
                        .sort((a, b) => a.firstName.localeCompare(b.firstName))
                        .map(({ username, firstName, lastName, deliveryTeamMemberRole, active }) => (
                                <div
                                    key={username} className='event_form__items-section__item-wrapper'
                                >
                                    <Text
                                        className='event_form__items-item-label'
                                        message={`${firstName} ${lastName}`}
                                        withEllipsis
                                    />
                                    <DeliveryTeamRole
                                        deliveryMemberRole={deliveryTeamMemberRole}
                                        deliveryMemberRoles={deliveryMemberRoles}
                                        username={username}
                                        setDeliveryMemberRole={setDeliveryMemberRole}
                                        intl={intl}
                                        shouldRenderIcon={active !== undefined ? active : true}
                                    />
                                    <DefaultButton
                                        text={<FormattedMessage {...REMOVE_TEXT} />}
                                        modifier='remove'
                                        onClick={() => removeDeliveryItem(username)}
                                        className='event_form__items-section__remove-item-button'
                                    />
                                </div>
                            )
                        )
                }
            </div>
            <MultiSelectButton
                searchWithDebounce
                className='event_form__items-section__add-button'
                items={selectableDeliveryTeamItems}
                disabled={assignedDeliveryTeamItems}
                value={assignedDeliveryTeamItems}
                keyProperty='username'
                nameProperty='fullName'
                filterHandler={searchDeliveryTeamItems}
                text={
                    <FormattedMessage
                        id='oe.deliveryTeam.add'
                        description='Button text'
                        defaultMessage='{prefix}Add Delivery Staff'
                        values={{
                            prefix: '+ '
                        }}
                    />
                }
                applyButtonText={addText()}
                resetButtonText={cancelText()}
                onChange={setAssignedDeliveryTeam}
                onClick={fetchDeliveryTeamItems}
            />
        </div>
    );
});
